import deepmerge from 'deepmerge'
import { init } from './state'

export default {
  /**
   * 組織ステート一式を設定する
   *
   * @param {State} state
   * @param {Object} org 組織情報
   */
  setData (state, org) {
    const data = deepmerge(init, org)
    for (const k in data) {
      state[k] = data[k]
    }
  },

  /**
   * ログイン後に表示するルートをクリアする
   *
   * @param {State} state
   */
  clearLoginTo (state) {
    state.loginTo = null
  },

  /**
   * ログイン後に表示するルートを設定する
   *
   * @param {State} state
   * @param {Route} route ログイン後に移動するルート
   */
  setLoginTo (state, route) {
    state.loginTo = route
  }
}
